import React from 'react';
import { Check, FileText, ShoppingCart, Repeat, HelpCircle } from 'lucide-react';
export function Included() {
  const items = [{
    title: '12 Semanas de Cenas',
    desc: '84 cenas planificadas (7 por semana) en formato rápido: ingredientes + pasos.',
    icon: FileText
  }, {
    title: 'Listas de Súper',
    desc: 'Organizadas por categorías para cada semana. Entras y sales del súper en 15 min.',
    icon: ShoppingCart
  }, {
    title: 'Motor Semanal',
    desc: 'Un sistema repetible para seguir después de la semana 12 sin volver a pensar.',
    icon: Repeat
  }, {
    title: 'Guía de Intercambio',
    desc: '¿No te gusta algo? Aprende a cambiarlo sin romper la estructura de la semana.',
    icon: HelpCircle
  }];
  return <section className="py-20 bg-white border-t border-stone-100" data-id="element-29">
      <div className="container mx-auto px-4" data-id="element-30">
        <div className="flex flex-col lg:flex-row gap-12 items-start" data-id="element-31">
          <div className="lg:w-1/3" data-id="element-32">
            <h2 className="text-3xl md:text-4xl font-bold text-stone-900 mb-6" data-id="element-33">
              Qué incluye exactamente
            </h2>
            <p className="text-lg text-stone-600 mb-8" data-id="element-34">
              Recibes un PDF completo e interactivo diseñado para usar en tu
              celular o tablet mientras cocinas.
            </p>
            <div className="bg-stone-50 p-6 rounded-2xl border border-stone-100" data-id="element-35">
              <h4 className="font-bold text-stone-900 mb-4" data-id="element-36">Compatible con:</h4>
              <div className="flex flex-wrap gap-2" data-id="element-37">
                {['Air Fryer', 'Instant Pot', 'Horno', 'Sartén'].map(tag => <span key={tag} className="px-3 py-1 bg-white border border-stone-200 rounded-full text-sm text-stone-600 font-medium" data-id="element-38">
                    {tag}
                  </span>)}
              </div>
            </div>
          </div>

          <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-39">
            {items.map((item, idx) => <div key={idx} className="flex gap-4 p-4 rounded-xl hover:bg-stone-50 transition-colors" data-id="element-40">
                <div className="shrink-0 w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-green-600" data-id="element-41">
                  <item.icon className="h-5 w-5" data-id="element-42" />
                </div>
                <div data-id="element-43">
                  <h3 className="font-bold text-stone-900 mb-1" data-id="element-44">
                    {item.title}
                  </h3>
                  <p className="text-stone-600 text-sm leading-relaxed" data-id="element-45">
                    {item.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}